import { apiFetch } from '../utils/apiFetch';
import { API_CONFIG } from '../constants';
import type { ActiveQRCodeResponse } from '../dtos/qr';

export type { ActiveQRCodeResponse } from '../dtos/qr';

export async function getActiveQRCode(
  podId: number | string
): Promise<ActiveQRCodeResponse> {
  const response = await apiFetch({
    url: API_CONFIG.ENDPOINTS.ACTIVE_QR(podId),
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch active QR code: ${response.status}`);
  }

  return response.json();
}

export async function regenerateQRCode(
  podId: number | string
): Promise<ActiveQRCodeResponse> {
  const response = await apiFetch({
    url: API_CONFIG.ENDPOINTS.REGENERATE_QR(podId),
    method: 'POST',
  });

  if (!response.ok) {
    throw new Error(`Failed to regenerate QR code: ${response.status}`);
  }

  return response.json();
}

//This api is only used for mock login
export async function startSession(qrToken: string): Promise<unknown> {
  const response = await apiFetch({
    url: API_CONFIG.ENDPOINTS.START_SESSION_QR,
    method: 'POST',
    body: {
      qrToken,
      patientId: 2, // Default mock patient ID
    },
  });

  if (!response.ok) {
    const text = await response.text().catch(() => '');
    throw new Error(`Start session failed (${response.status}): ${text}`);
  }

  return response.json();
}
